export default {
  "common-try-slogin": "Connect every person and app on the planet",
  "common-button-立即试用": "Try now",
  "common-consult": "Let's talk",
  "common-consult-descript":
    "For more information, please contact our sales and technical support team.",
  "common-customer": "Learn about Authing to help you grow fast",
  "common-more": "Learn more",
  "input-placeholder": "Your phone number",
  "try-on": "Get Started",
  "check-fun": "Learn Features",
  nav: {
    "nav-home": "Home",
    "nav-product": "Products",
    "nav-solution": "Solutions",
    "nav-resource": "Resources",
    "nav-cloud-native": "Cloud Native",
    "nav-case": "Cases",
    "nav-solution-medical": "Medical",
    "nav-solution-government": "Government",
    "nav-solution-education": "Education",
    "nav-solution-finance": "Finacial Services",
    "nav-solution-energy": "Energy",
    "nav-solution-game": "Game",
    "nav-solution-enterprise": "Technology",
    "nav-solution-software": "Software",
    "nav-solution-publisher": "Publisher",
    "nav-solution-wechat": "Wechat ecology",
    "nav-solution-idaas": "IDaaS replace IAM",
    "nav-solution-okta": "Move from Okta",
    "nav-solution-ad": "Move from AD",
    "nav-solution-cognito": "Move from AWS Cognito",
    "nav-solution-keycloak": "Keycloak VS Authing",
    "nav-solution-private-cloud": "Privately Deployed Identity Cloud",
    "nav-solution-mfa": "Adaptive MFA",
    "nav-solution-build-idaas": "Build your own IDaaS",
    "nav-solution-identity": "Synchronization and update of user information",
    "nav-solution-zero-trust": "Building zero trust network for organizations",
    "nav-solution-digital-identity": "Building digital identity for citizens",
    "nav-developer": "Developer",
    "nav-developer-center": "Developer Center",
    "nav-developer-center-descript": "Find out about Authing development",
    "nav-developer-community": "Developer Forum",
    "nav-developer-community-descript": "Communicate with Authing engineers",
    "nav-developer-document": "Docs",
    "nav-developer-document-descript": "Quickly implement auth into your apps",
    "nav-developer-blog": "Blog",
    "nav-price": "Pricing",
    "nav-abuoutus": "About",
    "nav-company-intro": "About Us",
    "nav-customer": "Customer Stories",
    "nav-customer-success": "Customer Success Service",
    "nav-console": "Console",
    "nav-personal": "Personal",
    "nav-login": "Login",
    "nav-mobile-login": "Login",
    "nav-logout": "Logout",
    "nav-type-customer": "Customer Stories",
    "nav-marketplace": "Partner Network",
    "nav-customer-hep": "Higher Education Press",
    "nav-customer-cnpn": "PetroChina",
    "nav-customer-southeast-university": "Southeast University",
    "nav-customer-xian-gong": "Xiangong Intelligent",
    "nav-customer-futu": "Futu Niuniu",
    "nav-case-description":
      "Startups, Unicorns and fortune 500 companies trust Authing’s software and APIs to sign in, authorize, and manage your employees & users.",
    "nav-developer-blog-descript":
      "Check out the latest from Authing developers",
    "nav-developer-doclink": "Common Document Jump",
    "nav-resource-whitepaper": "White Book",
    "nav-resource-demo": "Demo Center",
    "nav-resource-whitepaper-descript":
      "Feel the convenience of integrated Authing",
    "nav-resource-demo-descript":
      "Feel the efficient interactivity of the Authing console",
    "nav-type-application": "Advantages of Authing",
    "nav-type-company": "Company",
    "nav-type-about": "About Us",
    "nav-type-news": "Express ",
    "nav-type-APN": "Authing Partner Network",
    "nav-type-APN-img":
      "//files.authing.co/authing-website/nav-about-img-new-en-update.png",
    "nav-about-financing": "Investors",
    "nav-about-news": "Big News",
    "nav-type-product": "Product",
    "nav-type-service": "Security and Service",
    "nav-product-extra-title": "Product advantages",
    "nav-type-industry": "Industry Solutions",
    "nav-type-scense": "Scenario Solutions",
    "nav-type-staff": "Workforce Identity",
    "nav-type-user": "Customer Identity",
    "nav-type-extend": "Extended functions",
    "nav-extend-database": "Connect to custom database",
    "nav-extend-pipeline": "Pipeline",
    "nav-extend-operate": "IDaaS operation platform",
    "nav-extend-maintenance": "IDaaS maintenance platform",
    "nav-extend-radius": "Radius",
    "nav-solution-extra-title": "WeChat ecological solution",
    "nav-solution-extra-subtitle":
      "As an excellent provider of identity management solutions, Authing will bring significant competitive advantages to enterprises in B2B, B2C, B2E or IoT scenarios: reducing development costs, improving security, and boosting production efficiency.",
    "nav-type-developer": "Related Resources Introduction",
    "nav-developer-extra-oidc": "Use OIDC",
    "nav-developer-extra-mfa": "Mobile security MFA",
    "nav-developer-extra-pipeline": "Custom Authenticate",
    "nav-developer-extra-pipeline-subtitle":
      "Flexible configuration of authentication",
    "nav-developer-extra-start": "Get Started",
    "nav-developer-extra-start-subtitle":
      "Make your apps available to millions of users",
    "nav-developer-extra-pipeline-img-default":
      "//files.authing.co/authing-website/nav-developer-pipeline-new-en.png",
    "nav-developer-extra-pipeline-img":
      "//files.authing.co/authing-website/nav-developer-pipeline-default-en.png",
    "nav-developer-extra-start-img-default":
      "//files.authing.co/authing-website/nav-developer-getstart-default-en.png",
    "nav-developer-extra-start-img":
      "//files.authing.co/authing-website/nav-developer-getstart-new-en.png",
    "nav-about-extra-title": "Learn about Authing",
    "news-blog1": "Authing Share｜Password: the cornerstone of security",
    "nav-tag-joinus": "Join Us",
    "learn-more": "Learn More",
    "nav-overview": "Overview",
    "news-blog2":
      "Following Facebook, LinkedIn exploded another 500 million data breaches, all key user information leaked out",
    "news-blog3":
      "How Theragun uses Authing to provide a unified login experience for millions of users",
  },
  footer: {
    "footer-product": "Features",
    "footer-product-advance": "Product Advantages",
    "footer-platform": "Open Platform",
    "footer-solution": "Solutions",
    "footer-platform-api": "Open API",
    "footer-platform-resource": "Develop Resources",
    "footer-support-doc": "Developer Doc",
    "footer-platform-problem": "FAQ",
    "footer-platform-example": "Integration Cases",
    "footer-support": "Technical Support",
    "footer-doc": "Developer Doc",
    "footer-support-community": "Developer Forum",
    "footer-support-Github": "Github",
    "footer-support-blog": "Technical Blog",
    "footer-company": "Company",
    "footer-company-joinus": "Careers",
    "footer-company-phone": "400-6197-031",
    "footer-company-email": "sales@authing.cn",
    "company-address-name": "Beijing address (total)",
    "branch-address-name": "Chengdu address (branch)",
    "mobile-total-company-address":
      " 6 / F, Weisheng building, Zhongguancun East Road, Haidian District, Beijing(Total)",
    "mobile-branch-company-address":
      "room 406, 4th floor, zone B, building 1, No. 200, Tianfu Fifth Street, hi tech Zone, Chengdu(branch)",
    "beijing-company-address":
      "6 / F, Weisheng building, Zhongguancun East Road, Haidian District, Beijing",
    "chengdu-company-address":
      "Room 406, 4th floor, zone B, building 1, No. 200, Tianfu Fifth Street, hi tech Zone, Chengdu",
    "footer-language": "Language",
    "footer-adress": "Beijing ICP No.19051205-1",
    "footer-copyright": "© Beijing Steamory Technology Co.",
    "footer-sitemap": "Site Map",
    "footer-okta": "OKTA",
    "footer-solution-wechat": "Wechat ecology",
    "footer-solution-cognito": "Move from AWS Cognito",
  },
  common: {
    "product-sso": "Single Sign-On",
    "product-mfa": "Multi-Factor Authentication",
    "product-comp": "Universal Directory",
    "product-verify": "Mobile Number Verification",
    "product-security": "Security & Compliance",
    "product-database": "Custom Database Connection",
    "product-authorization": "Authorization",
    "product-api": "API Access Verification",
    "product-user-management": "User Management",
    "product-user-directory": "User Directory",
    "product-life-cycle": "Lifecycle Management",
    "product-gateway": "Access Gateway",
    "product-gateway-integration": "Access Gateway",
  },
  button: {
    "try-now": "Try now",
    "buy-now": "Buy now",
    "see-more": "Learn more",
    "learn-more": "Learn more",
    "develop-consult": "development consultation",
    "develop-community": "Develop Doc",
    "contact-us": "Contact Us",
    "quick-start": "Quick start",
    consult: "Let's talk",
    "wait-consult": "Not now",
    linkDoc: "Learn more",
  },

  form: {
    name: "Name",
    phone: "Phone",
    company: "Company",
    other: "Remarks",
    submit: "Submit now",
    cancel: "Cancel",
    // "contact-form-title":
    //   "An expert will contact you within 15 minutes after completion",
    "contact-form-title": "Access to enterprise level solution",
    "contact-subtitle":
      "Authing has exported hands-on solutions to more than 28 industries. We are happy to share our experience with your organization and provide free demos.",
    "success-tip": "Submitted successfully! ",
    "success-wait-tip": "Experts are on their way...",
    "success-try-tip":
      "Do you want to try it for free during the waiting period?",
    "name-placeholder": "What do we hope we call you？",

    "phone-placeholder": "Our consultant will call you as soon as possible",

    "company-placeholder": "Please fill in your company information",
    position: "Position",
    "position-placeholder": "Please fill in your position information",
    "contact-name": "Name",
    "contact-way": "Phone",
    "contact-title": "Access to enterprise level solution",

    "contact-tip": "You can also contact our sales staff via WeChat or phone.",
    "apply-title": "Submit your application",
    "apply-name": "Name",
    "apply-email": "Email",
    "apply-type": "Type",
    "apply-position": "Delivery Position",
    "apply-method": "Resume delivery method",
    "mail-address": "Email address",
    "mail-title": "Mail Title: Name + Post Title",
    "mail-content": "Delivery content: Mail content + Attached resume",
    otherTip: "Would you like to contact a customer service representative?",
    otherTip1: "Please call",
    otherTip2: "contact us",
  },
  notice:
    "Authing is participating in HW operation for 10 working days. Please go to www.authing.co to learn more. Consulting Tel: 19816542466 or 17602502507",
  // notice:
  //   "The new version of Authing has been released on 2020-09-17, and its performance has improved by leaps and bounds. Consulting Tel: 176-0250-2507",
  linkDoc: "View Document",
  about: {
    title: "About Authing",
    description1:
      "Authing is the first full scene identity cloud product in China, which integrates all international mainstream identity authentication protocols, such as OIDC, OAuth 2.0, CAS, ad, LDAP, etc., to provide enterprises and developers with perfect and secure user authentication and access management services.",
    description2:
      "Authing was recognized as 「2020 national high tech enterprise」 by the Ministry of science and technology, and was selected as an「innovative enterprise in the field of identity management and access control」by China Academy of information and communications and was included in《 the 2019 white paper on network security industry 》. Authing has built excellent development methods, efficient office processes and secure its management system for excellent enterprises at home and abroad, such as PetroChina, AWS, Accenture, DEGO group, Southeast University, higher education press, etc.",
    qrcodePublic: "「Authing Identity Cloud」Public",
    qrcodeBusiness: "Business Cooperation",
  },
  logo: {
    中国石油: "CNPC",
    国家电网: "STATE GRID",
    丰田: "TOYOTA",
    招商银行: "CHINA MERCHANTS BANK",
    高等教育出版社: "HIGHER EDUCATION PRESS",
    东南大学: "SOUTHEAST UNIVERSITY",
    华西医院: "WEST CHINA HOSPITAL SICHUAN UNIVERSITY",
    德高集团: "JCDecaux",
    云测: "Tertin",
    盼达用车: "PAND-AUTO",
    THERAGUN: "THERAGUN",
    宾利: "Bentley",
    stackchat: "Stackchat",
    chatopera: "Chatopera",
    腾讯云: "Tencent Cloud",
    亚马逊: "AWS",
    乐智机器人: "LEZHI ROBOT-STEAM EDUCATION",
    文因互联: "MEMECT",
    金蝶: "Kingdee",
    freeCodeCamp: "freeCodeCamp",
    阿里云: "Aliyun",
    句子互动: "Juzi",
    华为云: "Hua Weiyun",
    金证优智: "Jin Zheng Youzhi",
    一清创新: "Yiqing innovation",
  },

  pageLink: {
    title: "Learn more",
    sso: {
      title: "Single Sign-On",
      description:
        "Single Sign-On is one of the solutions for integrating enterprise systems, ...",
    },
    mfa: {
      title: "Adapted Multi-Factor Authentication",
      description:
        "Multi-factor authentication (MFA) is a simple and effective...",
    },
    comp: {
      title: "Universal Login",
      description:
        "The guard helps developers shield themselves from many of the implementation...",
    },
    verify: {
      title: "Mobile Number Verification",
      description:
        "Relying on the official real name user information of wechat, users can...",
    },
    database: {
      title: "Custom Database Connection",
      description:
        "When you want to ensure data security or smooth migration of users, please use Authing...",
    },
    iam: {
      title: "IDaaS replace IAM",
      description:
        "With the rapid development of digital transformation and cloud computing, the dimensions...",
    },
    okta: {
      title: "Move from Okta",
      description:
        "By comparing with Okta from six dimensions of identity platform, workflow, directory,...",
    },
    wechat: {
      title: "Wechat ecology",
      description:
        "Authing quickly realize the identity authentication and user management of any web,...",
    },
    keycloak: {
      title: "Keycloak VS Authing",
      description:
        "Keycloak is an open-source software product designed to provide a single sign-on a...",
    },
    buildIdaas: {
      title: "Build your own IDaaS",
      description:
        "As businesses accelerate their digital transformation, 「identity and access management...",
    },
  },
};
